<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="5" cy="5" r="2" fill="currentColor"/>
    <circle cx="19" cy="5" r="2" fill="currentColor"/>
    <circle cx="12" cy="12" r="2" fill="currentColor"/>
    <circle cx="5" cy="19" r="2" fill="currentColor"/>
    <polyline points="5,5 12,12 19,5 5,19" stroke="currentColor" stroke-width="2" fill="none"/>
  </svg>
</template>
